import { app } from '../../../../app';
import { Controller } from './import.controller';

app.component('userPasswordManagerImport', {
    bindings: {
        account: '<',
        importFileTypes: '<',
    },
    controller: Controller,
    templateUrl: require('./import.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/user/public-user-accounts/import/import.component.js